import { API } from 'common/constants';
import useSurveyQuestionsData from 'modules/insights/hooks/useSurveyQuesionsData';
import { ALIGNMENT_ROUTES } from 'routes/routes.const';
import { useCompareUrlWithProjectId } from './route';

interface UseDatasetQuestionsProps {
  skip?: boolean;
  projectId: string;
}

function useDatasetQuestions(
  { skip, projectId }: UseDatasetQuestionsProps = { skip: false, projectId: '' }
) {
  const { compareUrl } = useCompareUrlWithProjectId();

  const request = compareUrl(ALIGNMENT_ROUTES.root, { includes: true })
    ? API.ALIGNMENT
    : API.SURVEY;
  const { data, isFetching, isLoading } = useSurveyQuestionsData(
    { request, projectId },
    { skip: skip ?? false }
  );

  return {
    data,
    isFetching,
    isLoading,
  };
}

export default useDatasetQuestions;
